import { render, staticRenderFns } from "./DocumentHeaderOutstandingBalance.vue?vue&type=template&id=c277f25e&scoped=true&lang=pug&"
import script from "./DocumentHeaderOutstandingBalance.vue?vue&type=script&lang=js&"
export * from "./DocumentHeaderOutstandingBalance.vue?vue&type=script&lang=js&"
import style0 from "./DocumentHeaderOutstandingBalance.vue?vue&type=style&index=0&id=c277f25e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c277f25e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VDataTable,VMenu})
